module.exports = __webpack_public_path__ + "img/logo-intl-white.307332d.png";